import styled from "styled-components";
import { BRAND_DARKEST, WHITE } from "@streeteasy/design-system/colors";
import componentSizes from "@streeteasy/design-system/constants/componentSizes";
import Button from "@streeteasy/design-system/deprecated/actions/button";
import buttonThemes from "@streeteasy/design-system/deprecated/actions/button/buttonThemes";
import TextLink from "@streeteasy/design-system/deprecated/actions/text-link";
import {
  PrimaryMedium,
  SecondaryMedium
} from "@streeteasy/design-system/typography";

import { smallScreen } from "src/shared/constants/screenSizes";

export const IndustryProfessionalSection = styled.section`
  background-color: ${BRAND_DARKEST};
  padding: 40px 48px 48px;
  text-align: center;

  @media screen and (max-width: ${smallScreen}px) {
    display: block;
    padding: 40px 24px;
  }
`;

export const IndustryProfessionalContainer = styled.div`
  @media screen and (max-width: ${smallScreen}px) {
    max-width: 420px;
    margin: 0 auto;
  }
`;

export const Title = styled(PrimaryMedium)`
  color: ${WHITE};
  padding: 3px 0 5px;
`;

export const SubTitle = styled(SecondaryMedium).attrs({ as: "p" })`
  color: ${WHITE};
  padding-bottom: 24px;
`;

export const SignInButton = styled(Button).attrs({
  size: componentSizes.LG,
  theme: buttonThemes.DARK_BG
})`
  cursor: pointer;
  margin-bottom: 13px;
`;

export const Link = styled(TextLink).attrs({
  color: WHITE
})`
  cursor: pointer;
  font-size: 18px;
  font-weight: 700;
  font-weight: normal;
`;
